import { render, staticRenderFns } from "./StudyProgramForm.Dialog.vue?vue&type=template&id=08d3aadc&scoped=true&"
import script from "./StudyProgramForm.Dialog.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramForm.Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramForm.Dialog.vue?vue&type=style&index=0&id=08d3aadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3aadc",
  null
  
)

export default component.exports